export const FONT_SIZE_WIDTH_RATIO = 0.6
export const FONT_SIZE_HEIGHT_RATIO = 1
